<template>
<section class="fix">
  <ul>
    <li>
      <img class="tel" src="./assets/qrcode.jpg">
      <div class="arrow_box">
        <img :src="qrcode">
        <!-- <qrcode :val="url" :size="120"></qrcode> -->
        <small>填写问卷，赢大奖！</small>
      </div>
    </li>
    <li @click="backToTop">
      <img class="top" src="./assets/top.png">
    </li>
  </ul>
</section>
</template>

<script>

function scrollTop (el, from = 0, to, duration = 500) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  function scroll (start, end, step) {
    if (start === end) return

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}

export default {
  props: ['qrcode'],
  data () {
    return {
      showWechatDot: false
    }
  },
  computed: {
    url () {
      return window.location.href
    }
  },
  mounted () {},
  beforeDestroy () {
  },
  methods: {
    backToTop () {
      scrollTop(window, document.documentElement.scrollTop || document.body.scrollTop, 0, 500)
    }
  },
  filters: {
  }
}
</script>

<style lang="sass" scoped>
=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.fix
  position: fixed
  z-index: 1000
  right: 0
  bottom: 100px
  +mobile
    display: none
  ul
    width: 52px
    border-bottom: 1px solid #d6dce3
    li.wechat
      display: flex
      justify-content: center
      align-items: center
      position: relative
      img.wechat
        width: 70%
      .follow.is-2
        display: none
        align-items: center
        font-size: 14px
        text-align: justify
        img
          flex-shrink: 0
          margin-right: 5px
      &:hover .follow
        display: flex
      .dot
        display: none
        &.active
          display: block
        position: absolute
        left: 72%
        top: 10%
        width: 18%
        height: 18%
        background-color: red
        border-radius: 50%
    li
      position: relative
      height: 52px
      border-top: 1px solid #d6dce3
      border-left: 1px solid #d6dce3
      background-color: #fff
      cursor: pointer
      &:first-of-type
        &:hover
          .arrow_box
            display: block
      &:nth-of-type(3)
        &:hover
          .anchor_point_partner
            display: block
      img.tel
        width: 22px
      img
        width: 29px
        display: block
        margin: 10px auto
      img.top
        margin-top: 15px
      &:hover
        background-color: #f5f7f8
      .arrow_box
        display: none
        position: absolute
        width: 155px
        right: 70px
        top: 0
        background-color: #fff
        padding: 10px 12px
        border: 1px solid #d6dce3
        text-align: center
        img
           width: 155px
           margin: 0
           // height: 155px
        .img
          width: 155px
          height: 155px
        small
          font-size: 13px
          color: #8e9ca9
        &:after, &:before
          left: 100%
          top: 22%
          border: solid transparent
          content: " "
          height: 0
          width: 0
          position: absolute
          pointer-events: none
        &:after
          border-color: rgba(255, 255, 255, 0)
          border-left-color: #fff
          border-width: 8px
          margin-top: -8px
        &:before
          border-color: rgba(214, 220, 227, 0)
          border-left-color: #d6dce3
          border-width: 9px
          margin-top: -9px
      .anchor_point_partner
        display: none
        position: absolute
        width: 153px
        right: 70px
        top: 0
        background-color: #fff
        padding: 14px 26px 10px 23px
        border: 1px solid #d6dce3
        color: #8e9ca9
        font-size: 15px
        text-align: center
        line-height: 22.5px
      .follow
        display: none
        position: absolute
        width: 286px
        right: 70px
        top: -4px
        padding: 0 15px
        background-color: #fff
        border: 1px solid #d6dce3
        &:after, &:before
          left: 100%
          top: 22%
          border: solid transparent
          content: " "
          height: 0
          width: 0
          position: absolute
          pointer-events: none
        &:after
          border-color: rgba(255, 255, 255, 0)
          border-left-color: #fff
          border-width: 8px
          margin-top: -8px
        &:before
          border-color: rgba(214, 220, 227, 0)
          border-left-color: #d6dce3
          border-width: 9px
          margin-top: -9px
        .border
          display: inline-block
          margin-right: 15px
          padding-right: 15px
          border-right: 1px solid #d6dce3
        img
          padding: 11px 0
          width: 106px
          display: inline-block
        .anchor_point_partner
          display: none
          position: absolute
          width: 153px
          right: 70px
          top: 0
          background-color: #fff
          padding: 14px 26px 10px 23px
          border: 1px solid #d6dce3
          color: #8e9ca9
          font-size: 15px
          text-align: center
          line-height: 22.5px
          &:after, &:before
            left: 100%
            top: 22%
            border: solid transparent
            content: " "
            height: 0
            width: 0
            position: absolute
            pointer-events: none
          &:after
            border-color: rgba(255, 255, 255, 0)
            border-left-color: #fff
            border-width: 8px
            margin-top: -8px
          &:before
            border-color: rgba(214, 220, 227, 0)
            border-left-color: #d6dce3
            border-width: 9px
            margin-top: -9px
        .anchor_point_image img
          width: 34px
    #anchor_point_wrapper
        display: none
</style>



// WEBPACK FOOTER //
// src/components/com-fix/fix.vue